<div class="jhm-modal-background">
  <div id="purchase-credits-modal" class="jhm-modal purchase-credits-modal">
    <button class="jhm-icon-button transparent close-modal-button" (click)="cancel()"><i class="fa-regular fa-times"></i></button>
    <header>
      <div class="title">
        <h2>Purchase Credit</h2>
      </div>
    </header>
    <div class="edit-body">
      How much credit would you like to add?
      <div class="product-options">
        @for (productOption of productOptions; track productOption) {
          <button class="jhm-button" [class.white]="productOption !== selectedProduct" [class.dark]="productOption === selectedProduct" [class.selected-product]="productOption === selectedProduct" (click)="selectProduct(productOption)">
            <i class="fa-light fa-envelope-open-dollar"></i>
            <!-- <img *ngIf="productOption !== selectedProduct" src="./assets/images/credit.svg">
            <img *ngIf="productOption === selectedProduct" src="./assets/images/white-credit.svg"> -->
            {{productOption | optionToValue}}
          </button>
        }
      </div>
    </div>
    <footer class="filled">
      <button class="jhm-button" (click)="cancel()">Cancel</button>
      <button class="jhm-button primary" (click)="pay()">Continue to Purchase</button>
    </footer>
  </div>
</div>


